import React from 'react';
import RoleListPage from '../RoleManagement/RoleListPage';
import { ROLE_CONFIGS } from '../RoleManagement/roleConfig';
import styles from './DistributorPage.module.css';

const DistributorPage: React.FC = () => (
  <RoleListPage config={ROLE_CONFIGS.distributor} styles={styles} />
);

export default DistributorPage;
